/** Default admin UI language (URL prefix). */
export const DEFAULT_UI_LANGUAGE = 'fr' as const;
export type UiLanguage = 'fr' | 'en';

export function normalizeUiLanguage(lang?: string | null): UiLanguage {
  if (lang === 'fr' || lang === 'en') return lang;
  return DEFAULT_UI_LANGUAGE;
}

export function isSupportedUiLanguage(lang?: string | null): lang is UiLanguage | 'en' {
  return lang === 'fr' || lang === 'en';
}
